var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconEyeCard = function SvgIconEyeCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M8 11.383a2.888 2.888 0 0 1 0-5.774 2.888 2.888 0 0 1 0 5.774m0-4.774a1.89 1.89 0 0 0-1.886 1.887A1.89 1.89 0 0 0 8 10.383a1.89 1.89 0 0 0 1.887-1.887A1.89 1.89 0 0 0 8 6.609"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M8 14.511c-2.506 0-4.873-1.467-6.5-4.013-.706-1.1-.706-2.894 0-4C3.134 3.95 5.5 2.484 8 2.484s4.867 1.467 6.493 4.014c.707 1.1.707 2.893 0 4C12.868 13.044 10.5 14.51 8 14.51M8 3.484c-2.153 0-4.213 1.294-5.653 3.554-.5.78-.5 2.14 0 2.92 1.44 2.26 3.5 3.553 5.653 3.553s4.214-1.293 5.653-3.553c.5-.78.5-2.14 0-2.92-1.44-2.26-3.5-3.554-5.653-3.554"
  })));
};
export default SvgIconEyeCard;